import React from "react"
import { Link, useHistory } from "react-router-dom"
import { Col, Row } from "reactstrap"
import toast from "react-hot-toast"

import settingsIcon from "../../../assets/images/icons/settings-icon.svg"
import { replaceSlashes } from "../../../utils/commonUtils"
import { DataTable } from "../../../components/DataTable"
import { useLocalPaginatedRequest } from "../../../hooks/useLocalPaginatedRequest"
import {
   GetCustomizationCategoryListing,
   UpdateGlobalCustomizationSequence,
} from "../../../api/api.service"
import { convertDateTime, dateTimeFormat } from "utils/dateFormatUtils"
import { DragDropContext, Droppable } from "react-beautiful-dnd"
import { APP_ROUTES } from "../../../helpers/routeHelpers"
import { getRoute } from "../../../helpers/routeHelpers"
import { SearchBox } from "../../../components/SearchBox"
import useRenderUsedIn from "hooks/useRenderUsedIn"
import TruncatedTextWithTooltip from "components/CustomTooltip/CustomTooltip"

const COLUMNS = {
   FEATURE_NAME: "Feature Name",
   DATE_EDITED: "Date Edited",
   NO_OF_ITEMS: "No. of Items",
   USED_IN: "Used In",
   ACTION: "Action",
}

const DATA_KEY = "data"
const TOTAL_KEY = "total"
const GlobalPersonalization = () => {
   const history = useHistory()

   const {
      data,
      isFetching,
      searchText,
      handleSearchChange,
      setData,
   } = useLocalPaginatedRequest({
      requestFn: GetCustomizationCategoryListing,
      searchInCustomParams: true,
      customParams: {
         column: "sequenceNo",
         limit: -1,
         page: 1,
      },
      deps: [],
      dataKey: DATA_KEY,
      totalKey: TOTAL_KEY,
   })

   const handleDragEnd = async result => {
      // A searched list is a subset; the reorder endpoint needs every row, so block it.
      if (searchText?.trim()) return
      if (!result.destination) return
      if (result.destination.index === result.source.index) return
      const previous = Array.from(data)
      const items = Array.from(data)
      const [moved] = items.splice(result.source.index, 1)
      items.splice(result.destination.index, 0, moved)
      setData(items)
      try {
         await UpdateGlobalCustomizationSequence({
            sequenceItems: items.map((item, index) => ({
               id: Number(item.id),
               sequenceNo: index,
            })),
         })
         toast.success("Global personalization order updated.")
      } catch (err) {
         setData(previous)
         toast.error("Failed to update global personalization order")
      }
   }

   const renderUsedIn = useRenderUsedIn({
      listKey: "configuratorTrailerCustomizations",
   })

   const handleNavigateToSettings = obj => {
      return history.push(
         getRoute(
            APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_CUSTOMIZATION_ITEMS,
            {
               categoryId: obj.id,
               categoryName: replaceSlashes(obj.name),
            }
         )
      )
   }

   return (
      <>
         <Link to={APP_ROUTES.CONFIGURATOR_TRAILERS}>
            <div className="d-flex align-items-center gap-2 configurator-top-link">
               <span className="configurator-global-arrow">&lt;</span>{" "}
               Configurator Settings
            </div>
         </Link>

         <div className="mb-3 trailer-container px-2">
            <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness trailer-btn-container">
               <h3 className="configurator-global-heading">Personalization</h3>
               <div />
            </div>
         </div>

         <div className="mb-3 px-2">
            <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness">
               <div className="status-search-con wh-im-dpgi-status me-2"></div>
               <div className="ad-location-search-box">
                  <SearchBox
                     inputClasses="vendor-search-input input-search"
                     labelClass="d-none"
                     placeholder="Search"
                     searchIcon={true}
                     searchIconClass="vendor-table-search-icon"
                     conClass="vendor-table-search-inner-class"
                     searchText={searchText}
                     onChange={handleSearchChange}
                  />
               </div>
            </div>
         </div>

         <Row>
            <Col md={12}>
               <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="global-personalization-categories">
                     {provided => (
                        <div
                           {...provided.droppableProps}
                           ref={provided.innerRef}
                        >
               <DataTable
                  isDraggable={!searchText?.trim()}
                  droppablePlaceholder={provided.placeholder}
                  data={data}
                  tableClasses="base-feature-table"
                  loading={isFetching}
                  config={[
                     {
                        title: COLUMNS.FEATURE_NAME,
                        render: row => {
                           return <TruncatedTextWithTooltip text={row.name} />
                        },
                     },
                     {
                        title: COLUMNS.DATE_EDITED,
                        render: row =>
                           convertDateTime({
                              date: row?.updatedAt,
                              customFormat:
                                 dateTimeFormat.casitaCustomDateFormat,
                              dateOnly: true,
                           }),
                     },
                     {
                        title: COLUMNS.USED_IN,
                        render: renderUsedIn,
                     },
                     {
                        title: COLUMNS.NO_OF_ITEMS,
                        render: row => (
                           <span className="text-primary ">
                              {row?.totalItems ?? 0}
                           </span>
                        ),
                     },
                     {
                        title: COLUMNS.ACTION,
                        render: row => (
                           <div className="d-flex gap-2 pointer">
                              <img
                                 src={settingsIcon}
                                 onClick={() => handleNavigateToSettings(row)}
                              />
                           </div>
                        ),
                     },
                  ]}
               />
                        </div>
                     )}
                  </Droppable>
               </DragDropContext>
            </Col>
         </Row>
      </>
   )
}

export default GlobalPersonalization
